import ImageCropper from '@/components/imageCropper/imageCropper';
import { postData } from '@/services/api.service';
import { data, fetchCroppedImage } from '@/utils/constants';
import {
  iPhone11,
  iPhone13,
  just_clickaway,
  priorityicon1,
  priorityicon2,
  priorityicon3,
} from '@/utils/imagepath';
import { ColorPicker } from 'primereact/colorpicker';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation } from 'swiper/modules';
import { ImageType } from '@/services/openai.service';
import { RootState } from '@/core/redux/store';
import { setTemplateImages } from '@/core/redux/commonSlice';
import AIContentWriter from '@/components/AIContentWriter';
import AIImageGenerator from '@/components/AIImageGenerator';
const MobileAppEditModal = ({ themeData, getThemeData }: any) => {
  const dispatch = useDispatch();
  const headerData = useSelector((state: RootState) => state.common.header);
  const templateImages = useSelector((state: RootState) => state.common.templateImages);
  const [template, setTemplate] = useState(headerData?.template);

  const [editData, setEditData] = useState<any>();
  const [activeTab, setActiveTab] = useState(0);
  const [cropImageHeight, setCropImageHeight] = useState('');
  const [cropImageWidth, setCropImageWidth] = useState('');
  const [selectedCropImage, setSelectedCropImage] = useState('');
  const [showCropModal, setShowCropModal] = useState<boolean>(false);
  const [imagedata, setImagedata] = useState<any>(null);

  // State for banner images from template_images
  const [bannerImages, setBannerImages] = useState<string[]>([]);
  
  // State for icon images from template_images
  const [iconImages, setIconImages] = useState<string[]>([]);

  const icons = [
    priorityicon1,
    priorityicon2,
    priorityicon3,
    priorityicon1,
    priorityicon2,
    priorityicon3,
    priorityicon1,
    priorityicon2,
    priorityicon3,
  ];

  const banner = [
    iPhone11,
    iPhone13,
    just_clickaway,
    iPhone11,
    iPhone13,
    just_clickaway,
  ];

  const saveJsonData = async () => {
    const payload = {
      cms_json: JSON.stringify(editData),
    };
    try {
      const response = await postData('save_cms_json', payload);
      if (response.status == 200 || response.status == 201) {
        getThemeData();
        toast.success('Theme Updated Successfully');
      }
    } catch (err) {
      console.error(err);
    } finally {
    }
  };

  const addCollection = () => {
    let updatedCollection: any = [
      ...editData.theme_1.home.section_5.check_list,
    ];

    let newCard = {
      icons: priorityicon1,
      title: '',
      count: '',
    };
    updatedCollection.splice(activeTab + 1, 0, newCard);
    setActiveTab(activeTab + 1);
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_1: {
        home: {
          ...prevJsonData.theme_1.home,
          section_5: {
            ...prevJsonData.theme_1.home.section_5,
            check_list: updatedCollection,
          },
        },
      },
    }));
  };

  const removeCollection = (index: any) => {
    let updatedCollection: any = [
      ...editData.theme_1.home.section_5.check_list,
    ];
    
    // Prevent deleting the last item
    if (updatedCollection.length <= 1) {
      toast.error('At least one check list item is required');
      return;
    }
    
    updatedCollection.splice(index, 1);
    
    // Adjust activeTab if necessary
    if (activeTab >= updatedCollection.length) {
      setActiveTab(updatedCollection.length - 1);
    } else if (activeTab > 0) {
      setActiveTab(activeTab - 1);
    }
    
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_1: {
        home: {
          ...prevJsonData.theme_1.home,
          section_5: {
            ...prevJsonData.theme_1.home.section_5,
            check_list: updatedCollection,
          },
        },
      },
    }));
  };

  const handleChange = (e: any, index?: any) => {
    const { value, name, type, checked } = e.target;
    let updatedCollection: any = [
      ...editData.theme_1.home.section_5.check_list,
    ];
    if (index != undefined) {
      updatedCollection = [...editData.theme_1.home.section_5.check_list];
      updatedCollection[index] = {
        ...updatedCollection[index],
        [name]: value,
      };
    }
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_1: {
        home: {
          ...prevJsonData.theme_1.home,
          section_5: {
            ...data.home.section_5,
            [name]: value,
            title:
              name === 'section_5.title'
                ? value
                : prevJsonData.theme_1.home.section_5.title,
            mobile_link_section: {
              ...prevJsonData.theme_1.home.section_5.mobile_link_section,
              [name]: value,
            },
            check_list: updatedCollection,
          },
        },
      },
    }));
  };

  const handleImageChange = (image: string, index: any) => {
    const updatedCollection = [...editData.theme_1.home.section_5.check_list];
    updatedCollection[index] = {
      ...updatedCollection[index],
      icons: image,
    };

    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_1: {
        home: {
          ...prevJsonData.theme_1.home,
          section_5: {
            ...prevJsonData.theme_1.home.section_5,
            ...prevJsonData.theme_1.home.section_5.check_list,
            check_list: updatedCollection,
          },
        },
      },
    }));
  };

  const handleImageChangeone = (image: string) => {
    setEditData((prevJsonData: any) => ({
      ...prevJsonData,
      theme_1: {
        ...prevJsonData.theme_1,
        home: {
          ...prevJsonData.theme_1.home,
          section_5: {
            ...prevJsonData.theme_1.home.section_5,
            banner: image,
          },
        },
      },
    }));
  };

  const handleCroppedImage = async (image: any) => {
    setShowCropModal(false);
    setImagedata(image);
    const imageLink = await fetchCroppedImage(image);
    if (imageLink != false) {
      handleImageChange(imageLink, activeTab);
    }
  };

  const handleCroppedImageTwo = async (image: any) => {
    setShowCropModal(false);
    setImagedata(image);
    const imageLink = await fetchCroppedImage(image);
    // if (imageLink != false && bannerImageChange == false) {
    //   handleImageChange(imageLink, activeTab);
    // }
    if (imageLink != false) {
      handleImageChangeone(imageLink);
    }
  };

  const updateImageSectionOne = async (e: any) => {
    const image = e.target.files[0];
    // setCropImageHeight("150");
    // setCropImageWidth("150");
    // setSelectedCropImage(image);
    // setShowCropModal(true);
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImage(res.target.result);
      };
    }
  };

  const updateImageSectionTwo = async (e: any) => {
    const image = e.target.files[0];
    // setCropImageHeight("150");
    // setCropImageWidth("150");
    // setSelectedCropImage(image);
    // setShowCropModal(true);
    if (image instanceof File) {
      const reader = new FileReader();
      reader.readAsDataURL(image);
      reader.onload = (res: any) => {
        handleCroppedImageTwo(res.target.result);
      };
    }
  };
  // Load banner images from Redux store (using 'image' key for square/general images)
  useEffect(() => {
    if (templateImages && typeof templateImages === 'object') {
      const templateKey = template ? `template${template}` : 'template1';
      const currentTemplate = templateImages[templateKey];
      const images = currentTemplate?.image || [];
      
      if (Array.isArray(images) && images.length > 0) {
        // Filter images by resolution - for mobile app section, show square images (aspect ratio between 0.9 and 1.1)
        const filteredImages = images.filter((img: any) => {
          if (!img.resolution) return true;
          
          const [width, height] = img.resolution.split('x').map(Number);
          const aspectRatio = width / height;
          
          // Filter for square images (aspect ratio between 0.9 and 1.1, typically 1024x1024, 512x512, etc.)
          return aspectRatio >= 0.9 && aspectRatio <= 1.1;
        });
        
        const imageUrls = filteredImages.map((img: any) => img.url);
        setBannerImages(imageUrls);
      } else {
        setBannerImages([]);
      }
    } else {
      setBannerImages([]);
    }
  }, [templateImages, template]);

  // Load icon images from Redux store
  useEffect(() => {
    if (templateImages && typeof templateImages === 'object') {
      const templateKey = template ? `template${template}` : 'template1';
      const currentTemplate = templateImages[templateKey];
      const icons = currentTemplate?.icon || [];
      
      if (Array.isArray(icons) && icons.length > 0) {
        const imageUrls = icons.map((img: any) => img.url);
        setIconImages(imageUrls);
      } else {
        setIconImages([]);
      }
    } else {
      setIconImages([]);
    }
  }, [templateImages, template]);

  useEffect(() => {
    setEditData(themeData);
  }, [themeData]);

  useEffect(() => {
    if (editData != undefined) {
      setEditData(editData);
    }
  }, [editData]);

  // Auto-generate prompt based on mobile app section context for Banner
  const generateAutoPromptBanner = (): string => {
    const title = editData?.theme_1?.home?.section_5?.title || '';
    const paragraph = editData?.theme_1?.home?.section_5?.paragraph || '';
    
    // Build context-based prompt
    let contextPrompt = 'modern professional mobile app image for website section';
    
    if (title || paragraph) {
      const contextParts: string[] = [];
      if (paragraph) {
        const keywords = paragraph.split(' ').slice(0, 5).join(' ');
      }
      contextPrompt += `, ${contextParts.join(', ')}`;
    }
    
    // Add mobile app banner-specific styling
    contextPrompt += ', clean modern aesthetic, professional mobile app design, smartphone display, vibrant colors, high quality, no text, no words, no letters, no typography';
    
    return contextPrompt;
  };

  // Auto-generate prompt based on card context for Icons
  const generateAutoPromptIcon = (): string => {
    const currentCard = editData?.theme_1?.home?.section_5?.check_list?.[activeTab];
    const title = currentCard?.title || '';
    
    // Build context-based prompt
    let contextPrompt = 'modern professional icon for mobile app feature';
    
    if (title) {
      contextPrompt += `, related to "${title}"`;
    }
    
    // Add icon-specific styling
    contextPrompt += ', clean modern aesthetic, minimalist design, suitable for icon, vibrant colors, high quality, clean background, no text, no words, no letters, no typography';
    
    return contextPrompt;
  };

  // Handle AI banner image save
  const handleAIImageSave = (imageUrl: string) => {
    // Set the banner image
    handleImageChangeone(imageUrl);
    
    // Add to banner images array for slider
    setBannerImages(prevImages => [...prevImages, imageUrl]);
  };

  // Handle AI icon save
  const handleAIIconSave = (iconUrl: string) => {
    // Set the icon on the current active card
    handleImageChange(iconUrl, activeTab);
    
    // Add to icon images array for slider
    setIconImages(prevIcons => [...prevIcons, iconUrl]);
  };

  return (
    <>
      <div className="modal-dialog modal-lg modal-dialog-centered theme-edit-modal">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">Section Five Theme Edit</h5>
            <button
              type="button"
              className="btn-close"
              data-bs-dismiss="modal"
              aria-label="Close"
            ></button>
          </div>
          <div className="modal-content modal-body">
            <div className="edit-section">
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">
                      Title<small>(max 250 char)</small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      name="section_5.title"
                      value={editData?.theme_1?.home?.section_5?.title}
                      onChange={handleChange}
                      maxLength={250}
                    />
                  </div>
                  <div className="mb-3">
                    <div className="d-flex align-items-center mb-2 flex-wrap gap-2">
                      <label className="form-label mb-0 mr-2">
                        Paragraph
                      </label>
                      <AIContentWriter
                        onContentGenerated={(content) => {
                          handleChange({
                            target: {
                              name: 'paragraph',
                              value: content,
                            },
                          });
                        }}
                        contentType="mobile_app_description"
                        placeholder="Describe what you want in your paragraph. Example: 'Write about mobile app features and benefits'"
                        context="This is for a mobile app section description"
                      />
                    </div>
                    <textarea
                      className="form-control"
                      name="paragraph"
                      value={editData?.theme_1?.home?.section_5?.paragraph}
                      onChange={handleChange}
                      maxLength={1200}
                      rows={3}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md">
                <div className="mb-3">
                  <label className="form-label">header 1 Color</label>
                  <div className="input-group color-change">
                    <input
                      type="text"
                      className="form-control"
                      name="h2color"
                      value={editData?.theme_1?.home?.section_5?.h2color}
                      onChange={handleChange}
                    />
                    <ColorPicker
                      name="h2color"
                      format="hex"
                      onChange={handleChange}
                      value={editData?.theme_1?.home?.section_5?.h2color}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md">
                <div className="mb-3">
                  <label className="form-label">header 2 Color</label>
                  <div className="input-group color-change">
                    <input
                      type="text"
                      className="form-control"
                      name="h3color"
                      value={editData?.theme_1?.home?.section_5?.h3color}
                      onChange={handleChange}
                    />
                    <ColorPicker
                      name="h3color"
                      format="hex"
                      onChange={handleChange}
                      value={editData?.theme_1?.home?.section_5?.h3color}
                    />
                  </div>
                </div>
              </div>
              <div className="col-md">
                <div className="mb-3">
                  <label className="form-label">paragraph Color</label>
                  <div className="input-group color-change">
                    <input
                      type="text"
                      className="form-control"
                      name="paracolor"
                      value={editData?.theme_1?.home?.section_5?.paracolor}
                      onChange={handleChange}
                    />
                    <ColorPicker
                      name="paracolor"
                      format="hex"
                      onChange={handleChange}
                      value={editData?.theme_1?.home?.section_5?.paracolor}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-12">
                <label className="form-label">Banner</label>
                <div className="img-bg active">
                  <img
                    src={editData?.theme_1?.home?.section_5?.banner}
                    alt="Hero Image"
                    style={{ maxWidth: '100%', height: 'auto', borderRadius: '8px' }}
                  />
                </div>
                <div className="img-options">
                  <div className="row">
                    <div className="col-md-12">
                      {bannerImages.length > 0 ? (
                        <Swiper
                          spaceBetween={15}
                          navigation={true}
                          modules={[Navigation]}
                          breakpoints={{
                            640: {
                              slidesPerView: 1,
                            },
                            768: {
                              slidesPerView: 4,
                            },
                            1024: {
                              slidesPerView: 6,
                            },
                          }}
                          className="homejson-slider"
                        >
                          {bannerImages.map((image: string, index: number) => {
                            return (
                              <SwiperSlide key={index}>
                                <div
                                  className="img-option"
                                  onClick={() => handleImageChangeone(image)}
                                >
                                  <img
                                    src={image}
                                    alt="Banner Image"
                                    className="img-fluid"
                                    style={{ borderRadius: '4px', objectFit: 'cover', width: '100%', height: '80px' }}
                                  />
                                </div>
                              </SwiperSlide>
                            );
                          })}
                        </Swiper>
                      ) : (
                        <div style={{ padding: '20px', textAlign: 'center', color: '#999', border: '1px dashed #ddd', borderRadius: '8px' }}>
                          No images available. Upload or generate with AI.
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            {/* AI Image Generator */}
            <AIImageGenerator
              generateAutoPrompt={generateAutoPromptBanner}
              onSave={handleAIImageSave}
              imageType="image"
              defaultWidth="1024"
              defaultHeight="1024"
              title="AI Image"
              autoGenerate={true}
              template={template}
            />
            <div className="mb-3">
              <label className="form-label">Upload Image</label>
              <input
                type="file"
                accept="image/*"
                className="form-control"
                name="image"
                onChange={updateImageSectionTwo}
              />
            </div>
            <div className="edit-section">
              <ul className="nav nav-tabs">
                <Swiper
                  spaceBetween={15}
                  navigation={true}
                  modules={[Navigation]}
                  breakpoints={{
                    640: {
                      slidesPerView: 1,
                    },
                    768: {
                      slidesPerView: 2,
                    },
                    1024: {
                      slidesPerView: 3,
                    },
                  }}
                  className="homejson-slider"
                >
                  {editData?.theme_1?.home?.section_5?.check_list.map(
                    (card: any, index: any) => (
                      <SwiperSlide key={index}>
                        <li key={index} className="nav-item nav-option nav-option-wrapper">
                          <a
                            className={`nav-link ${
                              activeTab === index ? 'active' : ''
                            }`}
                            onClick={() => setActiveTab(index)}
                          >
                            Check List {index + 1}
                          </a>
                          <a
                            className="nav-option-close"
                            onClick={() => {
                              removeCollection(index);
                            }}
                          >
                            <i className="fas fa-times" aria-hidden="true"></i>
                          </a>
                        </li>
                      </SwiperSlide>
                    )
                  )}
                </Swiper>
              </ul>
              <div className="tab-content">
                {editData?.theme_1?.home?.section_5?.check_list.map(
                  (card: any, index: any) => (
                    <div
                      key={index}
                      className={`tab-pane fade ${
                        activeTab === index ? 'show active' : ''
                      }`}
                    >
                      <div className="row">
                        <div className="col-md-12">
                          <div className="img-bg active text-center">
                            <img
                              src={card.icons}
                              alt={`Card Icon ${index + 1}`}
                              style={{ maxWidth: '150px', height: 'auto', borderRadius: '8px' }}
                            />
                          </div>
                          <div className="img-options w-100">
                            {iconImages.length > 0 ? (
                              <Swiper
                                spaceBetween={15}
                                navigation={true}
                                modules={[Navigation]}
                                breakpoints={{
                                  640: {
                                    slidesPerView: 1,
                                  },
                                  768: {
                                    slidesPerView: 4,
                                  },
                                  1024: {
                                    slidesPerView: 6,
                                  },
                                }}
                                className="homejson-slider"
                              >
                                {iconImages.map((icon, iconIndex) => (
                                  <SwiperSlide key={iconIndex}>
                                    <div
                                      className="img-option"
                                      onClick={() =>
                                        handleImageChange(icon, index)
                                      }
                                    >
                                      <img
                                        src={icon}
                                        alt="Icon"
                                        className="img-fluid"
                                        style={{ borderRadius: '4px', objectFit: 'cover', width: '100%', height: '80px' }}
                                      />
                                    </div>
                                  </SwiperSlide>
                                ))}
                              </Swiper>
                            ) : (
                              <div style={{ padding: '20px', textAlign: 'center', color: '#999', border: '1px dashed #ddd', borderRadius: '8px' }}>
                                No icons available. Upload or generate with AI.
                              </div>
                            )}
                          </div>
                        </div>
                      </div>
                      <div className="mb-3">
                        <label className="form-label">
                          Title<small>(max 250 char)</small>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="title"
                          value={card.title}
                          onChange={(e) => handleChange(e, index)}
                          maxLength={250}
                        />
                      </div>
                      <div className="mb-3">
                        <label className="form-label">
                          Count<small>(max 10 char)</small>
                        </label>
                        <input
                          type="text"
                          className="form-control"
                          name="count"
                          value={card.count}
                          onChange={(e) => handleChange(e, index)}
                          maxLength={10}
                        />
                      </div>
                      {/* AI Icon Generator */}
                      <AIImageGenerator
                        generateAutoPrompt={generateAutoPromptIcon}
                        onSave={handleAIIconSave}
                        imageType="icon"
                        defaultWidth="128"
                        defaultHeight="128"
                        title="AI Icon"
                        autoGenerate={true}
                        template={template}
                      />
                      <div className="mb-3">
                        <label className="form-label">Upload Image</label>
                        <input
                          type="file"
                          accept="image/*"
                          className="form-control"
                          name="image"
                          onChange={updateImageSectionOne}
                        />
                      </div>
                    </div>
                  )
                )}
              </div>
            </div>
            <div className="add-section">
              <div className="row">
                <div
                  onClick={() => {
                    addCollection();
                  }}
                  className="col text-center"
                >
                  Add Card<i className="fas fa-plus-square ms-2"></i>
                </div>
              </div>
            </div>
            <div className="edit-section">
              <div className="row">
                <div className="col">
                  <h4>Mobile Link Section</h4>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Android Link</label>
                    <input
                      type="text"
                      className="form-control"
                      name="android_link"
                      value={
                        editData?.theme_1?.home?.section_5?.mobile_link_section
                          ?.android_link
                      }
                      onChange={handleChange}
                    />
                  </div>
                </div>
                <div className="col">
                  <div className="mb-3">
                    <label className="form-label">Ios Link</label>
                    <input
                      type="text"
                      className="form-control"
                      name="ios_link"
                      value={
                        editData?.theme_1?.home?.section_5?.mobile_link_section
                          ?.ios_link
                      }
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>
            <div className="mb-3">
              <button
                type="submit"
                data-bs-dismiss="modal"
                className="btn primary-btn"
                onClick={() => {
                  saveJsonData();
                }}
              >
                Save Changes
              </button>
            </div>
          </div>
        </div>
      </div>
      {showCropModal ? (
        <>
          <div
            className="modal modal-sm-crop fade show onboarding-modal settings cropModal"
            id="crop-modal"
            tabIndex={-1}
            aria-labelledby="crop-modal"
            aria-hidden="true"
            style={{ display: 'block' }}
          >
            <ImageCropper
              src={selectedCropImage}
              height={cropImageHeight}
              width={cropImageWidth}
              handleCrop={handleCroppedImage}
              close={() => {
                setShowCropModal(false);
              }}
            />
          </div>
        </>
      ) : null}
    </>
  );
};

export default MobileAppEditModal;
